/**
 * Sidebar link metadata (no icons) — shared by navSections.js and unit tests.
 * ESM for Vite/browser. Jest uses navSectionLinks.cjs — keep both in sync.
 */

import { buildWebNavSectionLinks } from '../../shared/navConfig.mjs';

/** @type {ReturnType<typeof buildWebNavSectionLinks>} */
export const NAV_SECTION_LINKS = buildWebNavSectionLinks();

export function flattenNavSectionLinks(sections = NAV_SECTION_LINKS) {
  return sections.flatMap((section) => section.items);
}
